<template lang="pug">
  main
    NavBarResumen
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  Resumen de Actividades &nbsp
              i.fas.fa-clipboard-list
        .columns
          .column.is-hidden-mobile.is-9-desktop.column-selects
            .field
                input#oALL.is-checkradio.is-primary(type='radio', value='ALL' v-model='selectedUbicacion')
                label.is-size-6(for='oALL') TODAS

                input#oIRGE.is-checkradio.is-primary(type='radio', value='IRGE' v-model='selectedUbicacion' checked='checked')
                label.is-size-6(for='oIRGE') IRGE

                input#oTPA.is-checkradio.is-primary(type='radio', value='TPA' v-model='selectedUbicacion')
                label.is-size-6(for='oTPA') TPA

                input#oEB00.is-checkradio.is-primary(type='radio', value='EB00' v-model='selectedUbicacion')
                label.is-size-6(for='oEB00') EB00

                input#oEB01.is-checkradio.is-primary(type='radio', value='EB01' v-model='selectedUbicacion')
                label.is-size-6(for='oEB01') EB01

                input#oEB02.is-checkradio.is-primary(type='radio', value='EB02' v-model='selectedUbicacion')
                label.is-size-6(for='oEB02') EB02

                input#oEB03.is-checkradio.is-primary(type='radio', value='EB03' v-model='selectedUbicacion')
                label.is-size-6(for='oEB03') EB03

                input#oEB04.is-checkradio.is-primary(type='radio', value='EB04' v-model='selectedUbicacion')
                label.is-size-6(for='oEB04') EB04

                input#oERM.is-checkradio.is-primary(type='radio', value='ERM' v-model='selectedUbicacion')
                label.is-size-6(for='oERM') ERM

                input#oDucto.is-checkradio.is-primary(type='radio', value='LPGD' v-model='selectedUbicacion')
                label.is-size-6(for='oDucto') Ducto
                
                input#oSISTEMAS.is-checkradio.is-primary(type='radio', value='SISTEMAS' v-model='selectedUbicacion')
                label.is-size-6(for='oSISTEMAS') SIST.

                input#oINSTRUM.is-checkradio.is-primary(type='radio', value='INSTRUMENTACION' v-model='selectedUbicacion')
                label.is-size-6(for='oINSTRUM') INST.
        .columns
          .column.is-4-desktop.is-12-mobile
            | Mes de la Resúmen:
            .field
              .control
                flat-pickr(
                  v-model='mesSelected'
                  :config="config"
                  class="input"
                )
          .column.is-12-mobile.is-9-tablet.is-hidden-desktop.column-dropdowns
            .field
              .select.is-rounded.select-dropdowns-container
                select.select-dropdowns(v-model="selectedUbicacion")
                  option(value="ALL" checked) TODAS
                  option IRGE
                  option TPA
                  option EB00
                  option EB01
                  option EB02
                  option EB03
                  option EB04
                  option ERM
                  option DUCTO
                  option SISTEMAS
                  option INSTRUMENTACION
        .columns(v-show="hayDatos")
          TbActividades(:actividades="rowsSelected")
        .columns(v-show="!hayDatos")
          .column.is-offset-one-quarter.is-half
            .notification
              button.delete
              |   No se encontraron actividades para esta fecha o criterios de b&uacute;squeda.
        .columns.column-blanco
</template>


<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarResumen from '@/components/resumen_Componentes/NavBarResumen.vue'
  import { mapState } from 'vuex'
  import TbActividades from './TbActividades.vue'
  import resumen_Services from '@/services/reportes/resumen'
  import flatPickr from 'vue-flatpickr-component'
  import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/plugins/monthSelect/style.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  

  export default {
    name: 'HomeResumen',
    components: { Loader, NavBarResumen, TbActividades, flatPickr },
    data() {
      return {
        isLoading: false,
        selectedUbicacion: 'ALL',
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only
          plugins: [
            new monthSelectPlugin({
              shorthand: true, //defaults to false
              dateFormat: "Y-m", //defaults to "F Y"
              altFormat: "Y-m", //defaults to "F Y"
              theme: "light" // defaults to "light"
            })
          ],
        },
        columns: [
          {
              label: 'Descripción',
              field: 'descripcion',
              sortable: true
          },
          {
              label: 'Fecha',
              field: 'fechaReg',
              sortable: true
          },
          {
              label: 'Usuario',
              field: 'usuario',
              sortable: true
          },
          {
              label: 'Ubicación',
              field: 'ubicacion',
              sortable: true
          },
          {
              label: 'Permiso',
              field: 'permiso',
              sortable: true
          },
          {
              label: 'Evidencias',
              field: 'evidencias',
              sortable: true
          }
        ],
        rows: [],
        mesSelected: '',
        rowsSelected: [],
        hayDatos: false
      }
    },
    watch: {
      selectedUbicacion() {
        switch (this.selectedUbicacion) {
          case 'SISTEMAS':
            this.rowsSelected = this.rows.filter(acts => acts.area === '3')
            break
          case 'INSTRUMENTACION':
            this.rowsSelected = this.rows.filter(acts => acts.area === '1')
            break
          case 'ALL':
            this.rowsSelected = this.rows
            break
          default:
            this.rowsSelected = this.rows.filter(acts => acts.ubicacion === this.selectedUbicacion)
            break
        }
        if (this.rowsSelected.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },
      mesSelected () {
        this.obtenerDataResumen()
      }
    },
    methods: {
      iniciarComponente() {
        this.mesSelected = moment().format('YYYY-MM')
        this.obtenerUser()
      },
      obtenerUser() {
        if (!this.userLogin) {
          this.$router.push('/')
        }
        this.obtenerDataResumen()
      },
      obtenerDataResumen () {
        let fechaBusqueda = new moment(this.mesSelected)
        let fechaI = fechaBusqueda.startOf('month').format('YYYY-MM-DD')
        let fechaF = fechaBusqueda.endOf('month').format('YYYY-MM-DD')
        resumen_Services.getActividades_Evidencias(fechaI, fechaF)
          .then(res => {
            console.log(res)
            this.rows = res
            this.rowsSelected = this.rows
            if (this.rowsSelected.length > 0) {
              this.hayDatos = true
            } else {
              this.hayDatos = false
            }
          })
      },
      
    },
    computed: {
    ...mapState(['logueado', 'userLogin', 'estacionSel'])
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .VueCarousel {
    max-width: 150px;
  }

  .column-blanco {
    padding-bottom: 50px;
  }

  .image.is-150x150 {
    height: 150px;
    widows: 150;
  }

  .table-responsive {
    overflow-x: auto;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/resumen_Componentes/HomeResumen.vue